if (!customElements.get("sticky-atc-bar")) {
  customElements.define(
    "sticky-atc-bar",
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        this.container = this.closest(".sticky-atc-bar");
        this.variants = JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        );
        this.idInput = this.querySelector('[name="id"]');
        this.sizeEl = this.querySelector("[data-sticky-size]");
        this.sizeIndex = Number(this.dataset.sizeOptionIndex || 0);
        this.optionSelects = Array.from(
          this.querySelectorAll("[data-option-index]")
        );
        this.mainProduct = document.querySelector(
          "product-info[id^='MainProduct']"
        );
        this.mainForm = document.querySelector(".f-main-product-form");
        this.trigger = this.mainForm && this.mainForm.querySelector('[name="add"]');

        this.optionSelects.forEach((select) =>
          select.addEventListener("change", () => this.onOptionChange())
        );

        this.querySelector("[data-change-selection]").addEventListener(
          "click",
          () => {
            const variantPicker =
              this.mainProduct && this.mainProduct.querySelector("variant-picker");
            (variantPicker || this.mainForm || document.body).scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        );

        this.observe();
        this.syncWithMainProductForm();
      }

      observe() {
        if (!this.trigger) {
          this.container.classList.add("sticky-atc-bar--show");
          return;
        }
        new IntersectionObserver(
          ([entry]) => {
            const scrolledPast =
              !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.container.classList.toggle(
              "sticky-atc-bar--show",
              scrolledPast
            );
          },
          { threshold: 0 }
        ).observe(this.trigger);
      }

      onOptionChange() {
        const selected = this.optionSelects.map((select) => select.value);
        const variant = this.variants.find((v) =>
          v.options.every((option, index) => option === selected[index])
        );
        this.render(variant);

        const picker =
          this.mainProduct && this.mainProduct.querySelector("variant-picker");
        if (!picker || !variant) return;
        picker
          .querySelectorAll("select, .variant-picker__option-values")
          .forEach((element, index) => {
            const value = variant.options[index];
            if (element.tagName === "SELECT") {
              element.value = value;
            } else {
              element
                .querySelectorAll("input")
                .forEach((radio) => (radio.checked = radio.value === value));
            }
          });
        picker.dispatchEvent(new Event("change"));
      }

      syncWithMainProductForm() {
        window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
          if (
            !this.mainProduct ||
            evt.data.sectionId !== this.mainProduct.dataset.section
          )
            return;
          const variant = evt.data.variant;
          this.optionSelects.forEach((select, index) => {
            if (variant) select.value = variant.options[index];
          });
          this.render(variant);
        });
      }

      render(variant) {
        this.currentVariant = variant;
        if (variant) this.idInput.value = variant.id;
        if (variant && this.sizeEl) {
          this.sizeEl.textContent = variant.options[this.sizeIndex];
        }
        this.updatePrice();
        this.updateButton();
      }

      updateButton() {
        const button = this.querySelector('[name="add"]');
        const label = button.querySelector("span:not(.f-icon)");
        const available = this.currentVariant && this.currentVariant.available;
        button.toggleAttribute("disabled", !available);
        label.textContent = available
          ? window.FoxThemeStrings.addToCart
          : window.FoxThemeStrings.soldOut;
      }

      updatePrice() {
        if (!this.currentVariant) return;
        const { compare_at_price, price } = this.currentVariant;
        const money_format = window.FoxThemeSettings.money_format;
        const priceWrapper = this.querySelector(".f-price");
        const salePrice = this.querySelector(".f-price-item--sale");
        const regularPrice = this.querySelector(".f-price-item--regular");
        const onSale = compare_at_price && compare_at_price > price;

        priceWrapper.classList.toggle("f-price--on-sale", !!onSale);
        priceWrapper.classList.toggle(
          "f-price--sold-out",
          !this.currentVariant.available
        );
        if (salePrice) salePrice.innerHTML = formatMoney(price, money_format);
        if (regularPrice) {
          regularPrice.innerHTML = formatMoney(
            onSale ? compare_at_price : price,
            money_format
          );
        }
      }
    }
  );
}
